<script>
  import {
    staffsComputed,
    rolesComputed,
    contactRolesMethods,
    addressTypesComputed,
  } from '@state/helpers'
  import {
    ChevronRightIcon,
    PlusIcon,
    XIcon,
    Edit3Icon,
    MailIcon,
    PhoneIcon,
  } from 'vue-feather-icons'
  import { ensureOnlyOnePrimary } from '@utils/select-one-primary-object'
  import {
    resolveTelephoneURI,
    resolvePhoneNumber,
  } from '@utils/phoneNumber'

  export default {
    components: {
      ChevronRightIcon,
      PlusIcon,
      XIcon,
      Edit3Icon,
      MailIcon,
      PhoneIcon,
    },
    props: {
      formError: {
        type: Object,
        required: true
      },
      contacts: {
        type: Array,
        required: true
      },
      messageRequest: {
        type: String,
        default: "to Request Work"
      },
      noLocation: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...staffsComputed,
      ...rolesComputed,
      ...addressTypesComputed,
    },
    methods: {
      ...contactRolesMethods,
      ensureOnlyOnePrimary,
      resolveTelephoneURI,
      resolvePhoneNumber,
      disabledPrimary(index, type, typeIndex) {
        return typeIndex === 0
      },
      tryToSelectOnePrimary(index, type = null, subIndex = null, keyName = 'is_primary') {
        this.$nextTick(() => {
          if (type) {
            this.ensureOnePrimary(this.contacts[index][type], subIndex, keyName, true);
          } else {
            this.ensureOnePrimary(this.contacts, index, keyName, true);
          }
        });
      },
      validateContactObject(formError, isValid, index, type) {
        if (!this.getPrimaryContactItem(index, type) ) {
          formError[`contacts.${index}.${type}`] = `Please enter at least one primary ${type}`
          return {...formError, isValid: false}
        }
        return {...formError, isValid: isValid}
      },
      collapseContactItem(contact, keyName) {
        contact[keyName].forEach((item, key) => {
          contact[keyName][key].is_edit = false
        })
        return contact
      },
      getPrimaryContactItem(index, type) {
        const object = this.contacts[index][type].find(object => object.is_primary);
        switch (type) {
          case 'emails':
            return (object && object.email) ? object : null;
          case 'phones':
            return (object && object.phone) ? object : null;
        }
      },

      // Contact
      addContact() {
        this.contacts.push(
          {
            roles: [],
            address: {},
            is_edit: true,
            can_request_work: false,
            is_display: false,
            phones: [
              {
                is_primary: true,
                is_edit: true
              }
            ],
            emails: [
              {
                is_primary: true,
                is_edit: true
              }
            ]
          }
        )
      },
      removeContact(index) {
        if (this.contacts[index].can_request_work && this.contacts.length > 1){
          this.ensureOnlyOnePrimary(this.contacts, index, 'can_request_work')
        }
        this.contacts.splice(index, 1)
      },
      toggleEditContact(index, toggle = true) {
        if (!toggle){
          let formError = {...this.formError, isValid: true};
          formError[`contacts.${index}.full_name`] = null
          formError[`contacts.${index}.emails`] = null
          formError[`contacts.${index}.phones`] = null

          formError = this.validateContactObject(formError, formError.isValid, index, 'emails')
          formError = this.validateContactObject(formError, formError.isValid, index, 'phones');
          if (!this.contacts[index].full_name) {
            formError[`contacts.${index}.full_name`] = 'The full name field is required.'
            formError.isValid = false
          }
          this.$emit('updateFormError', formError)
          if (!formError.isValid) {
            return this.$toasted.toast('Please check contact validation', { title: 'Error', variant: 'danger', colour: 'red' })
          }
        }

        let contact = { ...this.contacts[index], is_edit: toggle}
        contact = this.collapseContactItem(contact, 'phones');
        contact = this.collapseContactItem(contact, 'emails');
        this.contacts.splice(index, 1, contact)
        this.$set(contact, 'is_display', false)
      },
      canUpdateContact(index){
        const contact = this.contacts[index]
        if (contact && contact.full_name && ((contact.phones && contact.phones.length > 0) && contact.phones.findIndex(el => el.is_primary) !== -1) && ((contact.emails && contact.emails.length > 0) && contact.emails.findIndex(el => el.is_primary) !== -1)){
          return true
        }
        return false
      },
      canRemove(index){
        const usableContacts = this.contacts.filter(el => el && el.full_name && ((el.phones && el.phones.length > 0) && el.phones.findIndex(ph => ph.is_primary) !== -1) && ((el.emails && el.emails.length > 0) && el.emails.findIndex(em => em.is_primary) !== -1))
        if (usableContacts && usableContacts.length > 1){
          return true
        }
        if (this.contacts.length < 2){
          return false
        }
        return !this.canUpdateContact(index)
      },
      toggleDisplayMoreContact(index){
        const contact = this.contacts[index]
        this.$set(contact, 'is_display', !contact.is_display)
        const collapseToggle = `collapse-contact-detail-${index}__fb_collapse__`
        this.$root.$emit('fabric-collapse-toggle', { id: collapseToggle })
      },
    }
  };
</script>

<template>
  <div class="pt-1">
    <div v-for="(contact, index) in contacts" :key="index">
      <div
        v-if="!contact.is_edit"
        class="edit-form-item tw-flex-col md:tw-flex tw-mt-2 tw-mb-3"
        :class="{
          'md:tw-pr-12': !canRemove(index),
          'tw-pr-[8.5rem] md:tw-pr-24': canRemove(index),
        }">
        <div
          class="item-info !tw-h-11"
          :class="{ 'tw-border-b': contact.is_display }">
          <div class="tw-w-full tw-px-4 left-ct tw-flex tw-items-center tw-overflow-hidden">
            <div class="tw-flex fl-left-right tw-overflow-hidden">
              <div class="tw-min-w-24 tw-pr-1.5 tw-inline-flex tw-truncate">
                <span v-if="contact.can_request_work" class="block-status border rounded-pill pl-1 mr-2 tw-flex lg:tw-hidden">
                  <span class="status-icon status-completed" style="margin-right: 0.25rem;"/>
                </span>
                <span class="mg-r-10 text-bold tw-truncate">{{contact.full_name}}</span>
              </div>
              <div
                v-if="getPrimaryContactItem(index, 'phones')"
                class="tw-px-1.5 fl-inline-center tw-hidden xs:tw-flex tw-whitespace-nowrap">
                <PhoneIcon size="1.25x" class="tw-min-w-5 mg-r-5 stroke-blue no-hover"/><a class="tw-underline tw-text-positive" :href="`${resolveTelephoneURI(getPrimaryContactItem(index, 'phones').phone, $store.state.businesses.locale || 'AU')}`">{{resolvePhoneNumber(getPrimaryContactItem(index, 'phones').phone, $store.state.businesses.locale || 'AU')}}</a>
              </div>
              <div v-if="getPrimaryContactItem(index, 'emails')" class="tw-min-w-24 tw-px-1.5 fl-inline-center tw-hidden sm:tw-flex tw-whitespace-nowrap tw-truncate">
                <MailIcon size="1.25x" class="tw-min-w-5 mg-r-5 stroke-blue no-hover"/><a class="tw-truncate tw-underline tw-text-positive" :href="`mailto:${getPrimaryContactItem(index, 'emails').email}`">{{getPrimaryContactItem(index, 'emails').email}}</a>
              </div>
              <div class="ovf-x-hide tw-hidden lg:tw-inline-flex">
                <span v-if="contact.can_request_work" class="block-status border rounded-pill pl-1 tw-pr-2 mr-2 md:tw-flex tw-hidden">
                  <span class="status-icon status-completed"/><span class="status-text">Authorised</span>
                </span>
              </div>
            </div>
          </div>
          <div
            class="action-group mg-l-auto !tw-h-11"
            :class="{ 'tw-border-b tw-border-gray-300': contact.is_display }">
            <button
              class="btn btn-icon button-action button-action-active tw-block md:tw-hidden tw-group"
              @click="toggleDisplayMoreContact(index)">
              <BaseChevronRotate
                transition-class="rotate-360-180"
                double
                size="1.2x"
                :toggle="!!contact.is_display"
                :duration="500"
                class="tw-text-black group-hover:tw-text-white"
              />
            </button>
            <button
              class="btn btn-icon button-action button-action-positive"
              :class="{
                '!tw-rounded-br-none': (!canRemove(index) && contact.is_display),
              }"
              @click="toggleEditContact(index)">
              <Edit3Icon size="1x" />
            </button>
            <button
              v-if="canRemove(index)"
              class="btn btn-icon button-action button-action-negative"
              :class="{
                '!tw-rounded-br-none': contact.is_display,
              }"
              @click="removeContact(index)">
              <XIcon size="1x" />
            </button>
          </div>
        </div>
        <FabricCollapse
          :id="`collapse-contact-detail-${index}`"
          v-model="contact.is_display"
          hide-header
          :duration="500">
          <section class="tw-w-full md:tw-hidden show tw-justify-start">
            <div
              class="tw-px-5 tw-flex tw-flex-col tw-text-base tw-py-1"
              :class="{
                'tw-mr-[-22px]': !canRemove(index),
                'tw--mr-36': canRemove(index),
              }">
              <section v-if="contact.full_name" class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between">
                <span class="tw-w-full sm:tw-w-3/12">User:</span>
                <span class="tw-w-full sm:tw-w-9/12 tw-pl-2 sm:tw-pl-0 tw-pb-2 sm:tw-pb-0 sm:tw-text-right tw-overflow-ellipsis tw-truncate">{{contact.full_name}}</span>
              </section>
              <section class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between">
                <span class="tw-w-full sm:tw-w-1/2">Request Work:</span>
                <span class="tw-w-full sm:tw-w-1/2 tw-pl-2 sm:tw-pl-0 tw-pb-2 sm:tw-pb-0 sm:tw-text-right tw-overflow-ellipsis tw-truncate">{{contact.can_request_work ? 'yes' : 'no'}}</span>
              </section>
              <section v-if="getPrimaryContactItem(index, 'emails')" class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between">
                <span class="tw-w-full sm:tw-w-3/12">Email:</span>
                <span class="tw-w-full sm:tw-w-9/12 tw-underline tw-text-positive tw-pl-2 sm:tw-pl-0 tw-pb-2 sm:tw-pb-0 sm:tw-text-right tw-overflow-ellipsis tw-truncate"><a :href="`mailto:${getPrimaryContactItem(index, 'emails').email}`">{{getPrimaryContactItem(index, 'emails').email}}</a></span>
              </section>
              <section v-if="getPrimaryContactItem(index, 'phones')" class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between">
                <span class="tw-w-full sm:tw-w-3/12">Phone:</span>
                <span class="tw-w-full sm:tw-w-9/12 tw-underline tw-text-positive tw-pl-2 sm:tw-pl-0 tw-pb-2 sm:tw-pb-0 sm:tw-text-right tw-overflow-ellipsis tw-truncate"><a :href="`${resolveTelephoneURI(getPrimaryContactItem(index, 'phones').phone, $store.state.businesses.locale || 'AU')}`">{{resolvePhoneNumber(getPrimaryContactItem(index, 'phones').phone)}}</a></span>
              </section>
              <template v-if="contact.roles && contact.roles.length > 0">
                <span class="tw-w-full sm:tw-w-3/12">Roles:</span>
                <span v-for="(roles, rolesIndex) in contact.roles" :key="rolesIndex" class="tw-truncate">
                  <ChevronRightIcon size="1.2x" class="mg-r-5 stroke-blue no-hover tw-inline-flex"/>{{roles.name}}
                </span>
              </template>
            </div>
          </section>
        </FabricCollapse>
      </div>
      <div v-if="contact.is_edit" class=" border border-radius-20 tw-mt-2 tw-mb-3 pd-20 bg-gray">
        <div class="group-block">
          <!-- Base -->
          <section>
            <div class="lg:tw-flex-row tw-flex tw-flex-col">
              <div class="tw-w-full lg:tw-w-1/2 lg:tw-mr-3">
                <div :class="['form-group', { 'is-invalid': formError['contacts.' + index + '.full_name'] }]">
                  <label>Contact Full Name</label>
                  <input
                    v-model="contacts[index].full_name"
                    type="text"
                    class="form-control"
                    placeholder="E.g. Jane Doe" />
                  <p v-if="formError && formError['contacts.' + index + '.full_name']" class="text-danger">{{ formError['contacts.' + index + '.full_name'] }}</p>
                </div>
              </div>
              <div class="tw-w-full lg:tw-w-1/2 lg:tw-ml-3">
                <div :class="['form-group', { 'is-invalid': formError['contacts.' + index + '.role_id'] }]">
                  <label>Contact Role</label>
                  <BaseTagBox
                    v-model="contacts[index].roles"
                    :get-data="getContactRoles"
                  />
                  <span class="optional">Role of the contact within the customer business</span>
                  <p v-if="formError && formError['contacts.' + index + '.role_id']" class="text-danger">{{ formError['contacts.' + index + '.role_id'] }}</p>
                </div>
              </div>
            </div>
            <div :class="['form-group']">
              <label>Contact Permissions</label>
              <div class="tw-pt-2.5">
                <FabricCheckbox
                  v-model="contacts[index].can_request_work"
                  :disabled="contacts.length === 1"
                  :custom-width="19"
                  slot-classes="!tw-pl-3 tw-text-black"
                  switch
                  @update="tryToSelectOnePrimary(index, null, null, 'can_request_work')"
                >{{`Authorised ${messageRequest}`}}</FabricCheckbox>
              </div>
            </div>
          </section>

          <!-- Email -->
          <BaseEmail
            :index="index"
            :email-list="contacts[index].emails"
            :form-error="formError"
            :form-error-path="`contacts.${index}.emails`"
            :enforce-primary="tryToSelectOnePrimary"
          />

          <!-- Phone -->
          <BasePhone
            :index="index"
            :phones-list="contacts[index].phones"
            :form-error="formError"
            :form-error-path="`contacts.${index}.phones`"
            :enforce-primary="tryToSelectOnePrimary"
          />

          <div>
            <p v-if="formError && formError[`contacts.${index}.error`]" class="text-danger">{{ formError[`contacts.${index}.error`] }}</p>
          </div>

          <div class="tw-flex tw-flex-col xs:tw-flex-row tw-items-center tw-justify-between tw-pt-3">
            <button
              v-if="canRemove(index)"
              type="button"
              class="btn button button-dashed-danger xs:tw-mb-0 tw-w-5/12 xs:tw-w-px tw-mb-3"
              @click="removeContact(index)">
              Remove
            </button>
            <span v-else/>
            <button
              type="button"
              :disabled="!canUpdateContact(index)"
              class="btn button button-dashed-positive xs:tw-mb-0 tw-w-5/12 xs:tw-w-px"
              @click="toggleEditContact(index, false)">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="group-button">
      <button type="button" class="btn button-bd-dashed" @click="addContact">
        <div class=" fl-al-center">
          <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
          <span class="item-text">Add Contact</span>
        </div>
      </button>
    </div>
  </div>
</template>
